import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            了解更多关于屁屁影院的故事
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="p-6 md:p-10 rounded-2xl bg-background-50 border border-background-200/70">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-xl text-white"></i>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">
                {aboutInfo.title}
              </h3>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed whitespace-pre-line">
              {aboutInfo.content}
            </p>
            <div className="mt-6 flex flex-wrap gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-50 text-sm text-primary-700 font-medium">
                <i className="ri-shield-check-line"></i>
                <span>安全无毒</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-50 text-sm text-accent-700 font-medium">
                <i className="ri-flashlight-line"></i>
                <span>极速秒播</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-50 text-sm text-secondary-700 font-medium">
                <i className="ri-global-line"></i>
                <span>全球覆盖</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}